<template>
  <el-container>
    <el-header>
      <NavHeader></NavHeader>
    </el-header>
    <el-container :style="`height:${height - 60}px`">
      <el-aside>
        <NavAside></NavAside>
      </el-aside>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import NavHeader from '../components/Header'
import NavAside from '../components/Aside'

export default {
  name: 'Home',
  components: {
    NavHeader,
    NavAside
  },
  data () {
    return {
      height: document.body.clientHeight
    }
  }
}
</script>

<style scoped>
  .el-header{
    padding: 0!important;
    height: 60px!important;
    line-height: 60px;
  }
</style>
<style>
  .el-container{
    height: 100%;
  }
  .el-aside{
    width: auto!important;
    height: 100%;
  }
  .el-main{
    height: 100%;
  }
  .el-footer{
    height: auto!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue